export default {
	watchedLists: {},
	enactedMeasureSelector: "Measure--state-enacted",
	previewUserDefinedModifiersTimeout: null,

	initList(measuresContainerSelector, $propertiesContainer) {
		pp.log(
			"MEASURES initList for:",
			measuresContainerSelector,
			$propertiesContainer,
		);
		this.watchedLists[measuresContainerSelector] = {
			// Catch both inserted singleton Measures and Measure options in below observer
			measureElems: $(measuresContainerSelector).find(
				".MeasuresList, .MeasuresList .Measure--with-options .tab-content",
			),
			measuresCountEl: $propertiesContainer.find(
				".j-article-enacted-measures-count",
			),
			measuresTotalCostEl: $propertiesContainer.find(
				".j-article-enacted-measures-total-cost",
			),
			measuresTotalCostDescriptorEl: $propertiesContainer.find(
				".j-article-enacted-measures-total-descriptor",
			),
			remainingVotesEl: $propertiesContainer.find(".j-remaining-votes"),
			enactedArticleMeasureIds: [],
			enactedMeasuresTotalCost: 0,
		};
		// Just a wrapper to get the `measuresContainerSelector` into `handleInsertedNode`
		this.watchedLists[measuresContainerSelector].measureElems
			.observe()
			.on("insertNode", (event, measureElem) => {
				if ($(measureElem).hasClass(pp.measures.enactedMeasureSelector)) {
					pp.measures.handleInsertedNode(
						$(measureElem),
						measuresContainerSelector,
					);
					this.updateDisplayValues(measuresContainerSelector);
				}
			});

		$(measuresContainerSelector).one("destroyed destroyed_proxy", (event) => {
			// Child nodes will also trigger this listener, so check if the resp. target is actually the watched list
			if ($(event.target).is($(measuresContainerSelector))) {
				delete pp.measures.watchedLists[measuresContainerSelector];
			}
		});

		// Init once for all enacted Measures
		this.watchedLists[measuresContainerSelector].measureElems
			.find(`.${this.enactedMeasureSelector}`)
			.each((index, measureElem) => {
				pp.measures.handleInsertedNode(
					$(measureElem),
					measuresContainerSelector,
				);
			});
		this.updateDisplayValues(measuresContainerSelector);
		this.initUncollapseListener(measuresContainerSelector);
	},

	initUncollapseListener(measuresContainerSelector) {
		const $container = $(measuresContainerSelector);
		$container
			.find("[data-toggle='collapse']")
			.one("show.bs.collapse", (event) => {
				const $link = $(event.currentTarget);
				if (!$link.hasClass("Measure--with-options")) {
					pp.measures.loadMeasureContent($link.data());
				}
			});
	},

	// This is only used in _enacted_measures_per_phase_and_group
	initTabSwitchListener(toggleSelector) {
		$(toggleSelector).one("shown.bs.tab", (event) => {
			// @ts-expect-error
			const $tab = $($(event.currentTarget).attr("href"));
			$tab
				// @ts-expect-error
				.find(".Measure:not(.Measure--with-options), .Measure-option")
				.each((index, measureElem) => {
					this.loadMeasureContent($(measureElem).data());
				});
		});
		// Trigger each active element once now;
		// Account for doubly nested tab panes
		$(toggleSelector).each((index, elem) => {
			const $link = $(elem);
			if (!$link.parent().hasClass("active")) {
				return;
			}
			const $tabPane = $link.closest(".tab-pane");
			if ($link.is(":visible") || !$tabPane.length) {
				$link.trigger("shown.bs.tab");
			} else if ($tabPane.length) {
				$(`[data-target='#${$tabPane.attr("id")}']`).one(
					"shown.bs.tab",
					(event) => {
						$link.trigger("shown.bs.tab");
					},
				);
			}
		});
	},

	loadMeasureContent(measureData) {
		// pp.log("into loadMeasureContent", measureData);
		// @ts-expect-error
		$.ajax({
			url: `/measures/${measureData.measureId}`,
			dataType: "json",
			type: "GET",
			tryCount: 0,
			retryLimit: 3,
			timeout: 5000,
			data: {
				article_id: measureData.articleId,
				voted_on_draft_id: measureData.votedOnDraftId,
				draft_creatable: measureData.draftCreatable,
				show_as_closed: measureData.showAsClosed,
				show_vote_link: measureData.showVoteLink,
			},
			success: (responseJSON, status) => {
				const $panel = $(
					pp.measures.domElLookupString(
						measureData.articleId,
						measureData.measureId,
					),
				).find(".Measure__expandable");
				// pp.log("loadMeasureContent -- data, status, panel", responseJSON, status, $panel);
				$panel.html(responseJSON.measure_html);
				const $form = $panel.find("form");
				const $measureEl = $panel.closest(".Measure-option, .Measure");
				pp.measures.initMeasureEffects(
					measureData.measureId,
					measureData.articleId,
					$form.attr("data-show-effects-preview"),
					measureData.votedOnDraftId,
				);
				// @ts-expect-error
				$panel.find("a.popover-action").popover(); // The list of Measure egdes
				if (
					responseJSON.show_as_unproposable &&
					!$measureEl.hasClass("Measure--state-closed") &&
					!$measureEl.hasClass("Measure--state-enacted")
				) {
					$measureEl.addClass("Measure--state-closed");
				}
				if (responseJSON.show_as_unaffordable) {
					$measureEl.addClass("Measure--state-unaffordable");
				}
			},
			error: function (xhr, textStatus, errorThrown) {
				// pp.log("loadMeasureContent error", measureData.measureId, xhr, textStatus, errorThrown)
				if (textStatus == "timeout") {
					this.tryCount++;
					if (this.tryCount <= this.retryLimit) {
						$.ajax(this); // Try again
					} else {
						// TODO error msg
						pp.log(
							"loadMeasureContent unhandled error",
							xhr,
							textStatus,
							errorThrown,
						);
					}
				}
			},
		});
	},

	domElLookupString(articleId, measureId, includeMeasureOption = true) {
		let toReturn = `.Measure[data-article-id='${articleId}'][data-measure-id='${measureId}']`;
		if (includeMeasureOption) {
			toReturn += `, .Measure-option[data-article-id='${articleId}'][data-measure-id='${measureId}']`;
		}
		return toReturn;
	},

	measureOptionLinks(articleId, measureId) {
		return $(
			`a[href=".Measure-option[data-article-id='${articleId}'][data-measure-id='${measureId}']"`,
		);
	},

	initParentMeasureDropdown(parentMeasureId) {
		// pp.log("MEASURES initParentMeasureDropdown", parentMeasureId);
		const $parentMeasureEl = $(
			`.Measure--with-options[data-parent-measure-id='${parentMeasureId}']`,
		);
		const $dropdownMenu = $parentMeasureEl.find(".dropdown-menu");
		$parentMeasureEl
			.children(".Measure__expandable")
			.one("show.bs.collapse", () => {
				setTimeout(() => {
					// Needs to give the listener in `initMeasureEffects` some time to register first
					const firstVisibleDropdownEl = $dropdownMenu
						.find("a")
						.get()
						.find((dropdownEl) => {
							return (
								$(dropdownEl).data("showUnenactable") == true ||
								!$(dropdownEl).hasClass("Measure--state-closed")
							);
						});
					// `:visible` to select the first link that points to a visible Measure
					if (firstVisibleDropdownEl) {
						$(firstVisibleDropdownEl).trigger("click");
					} else {
						$parentMeasureEl
							.find("a[data-toggle='dropdown'] span:first")
							.text(I18n.t("global.inaccessible"));
					}
				}, 50);
			});
		$parentMeasureEl.find(".Measure-option").each(function () {
			const $measureOptionEl = $(this);
			let classes = "j-prevent-event-bubble-up";
			if ($measureOptionEl.hasClass("Measure--state-closed")) {
				classes += " Measure--state-closed";
			}

			$dropdownMenu.append(
				`<li>\
					<a href=".Measure-option[data-article-id='${$measureOptionEl.attr("data-article-id")}'][data-measure-id='${$measureOptionEl.attr("data-measure-id")}']"\
					data-show-unenactable=${$measureOptionEl.data("showUnenactable")}\
					data-toggle='tab'\
					class='${classes}'>${$measureOptionEl.find(".Measure__title").text()}</a>\
				</li>`,
			);
		});

		$dropdownMenu.find("a").on("click", (event) => {
			const $link = $(event.currentTarget);
			// @ts-expect-error
			const $measure = $($link.attr("href"));
			pp.viewHelpers.replaceDropdownTriggerText($link);
			pp.viewHelpers.manageDropdownActiveState($link);
			$link.closest(".dropdown").removeClass("open");
			// @ts-expect-error
			pp.measures.loadMeasureContent($measure.data());
		});
	},

	handleInsertedNode($measureElem, measuresContainerSelector) {
		pp.log("MEASURES into handleInsertedNode", $measureElem);
		const articleId = parseInt($measureElem.attr("data-article-id"), 10);
		const measureId = parseInt($measureElem.attr("data-measure-id"), 10);
		const cost = parseFloat($measureElem.attr("data-cost"));
		if (
			this.watchedLists[
				measuresContainerSelector
			].enactedArticleMeasureIds.indexOf([articleId, measureId]) != -1
		) {
			return;
		}

		this.watchedLists[measuresContainerSelector].enactedArticleMeasureIds.push([
			articleId,
			measureId,
		]);
		this.watchedLists[measuresContainerSelector].enactedMeasuresTotalCost +=
			cost;
	},

	updateMeasureInLists(articleId, measureId, measureHtml) {
		pp.log(
			"MEASURES updateMeasureInLists -- articleId, measureId",
			articleId,
			measureId,
		);
		const $externalContainer = $("#external-measures");
		const $presentMeasureElems = $(
			pp.measures.domElLookupString(articleId, measureId, false),
		);
		const $presentMeasureOptionElems = $(
			`.Measure-option[data-article-id='${articleId}'][data-measure-id='${measureId}']`,
		);
		// Determine where the `measureHtml should be inserted. The normal case is that a Measure has been enacted, but Measures of annulled Drafts (that just became enactable again)
		// should be inserted at the top of the list (just below `.j-enactable-measures-delimiter`)
		const delimiterSelector = $(measureHtml).hasClass("Measure--state-enacted")
			? ".j-enacted-measures-delimiter"
			: ".j-enactable-measures-delimiter";

		// Guard clause
		if (
			!$presentMeasureElems.length &&
			!$presentMeasureOptionElems.length &&
			!$externalContainer.length
		) {
			return false;
		}

		// For external Measures (from the New Work committee) the measure elem is present, but presented differently for non external measures.
		if (!$presentMeasureElems.length && $externalContainer.length) {
			$externalContainer.find(delimiterSelector).after(measureHtml);
			pp.measures.initUncollapseListener($externalContainer);
			return;
		}
		// else
		// For "normal" Measures in lists
		$presentMeasureElems.each(function (index, measureElem) {
			const $presentContainer = $(measureElem).closest(`.MeasuresList`);
			// For Measures in "normal" Measure lists
			if (!$presentContainer.length) {
				return; // Must be a Measure in a Draft view, or something weird we can't dealt with here
			}

			$(measureElem).remove();
			$presentContainer.find(delimiterSelector).after(measureHtml);
		});
		// For Measure options
		$presentMeasureOptionElems.each(function (index, measureOptionElem) {
			const $presentContainer = $(measureOptionElem).closest(`.MeasuresList`);
			// For Measures in "normal" Measure lists
			if (!$presentContainer.length) {
				return; // Must be a Measure in a Draft view, or something weird we can't deal with here
			}

			const $parent = $(measureOptionElem).parent();
			$(measureOptionElem).remove();
			$parent.append(measureHtml);
			$(
				`a[href=".Measure-option[data-article-id='${articleId}'][data-measure-id='${measureId}']"]`,
			).trigger("click"); // Show the tab pane of the inserted Measure
		});
	},

	replaceMeasureInRunningVote(articleId, measureId, expandedMeasureHtml) {
		$(".Draft--with-measures")
			.find(pp.measures.domElLookupString(articleId, measureId))
			.each((index, measureElem) => {
				if ($(measureElem).hasClass("Measure-option")) {
					// @ts-expect-error
					measureElem = $(measureElem).closest(".Measure");
				}
				$(measureElem).replaceWith(expandedMeasureHtml);
			});
		// @ts-expect-error
		$(".Draft--with-measures").find("a.popover-action").popover(); // The list of Measure egdes
	},

	markOpenedMeasures(articleMeasuresAsHash) {
		// pp.log("into markOpenedMeasures", articleMeasuresAsHash);
		Object.entries(articleMeasuresAsHash).forEach(([articleId, measureIds]) => {
			measureIds.forEach((measureId) => {
				const $openedMeasure = $(
					pp.measures.domElLookupString(articleId, measureId),
				);
				const $measureContainer = $($openedMeasure).closest(`.MeasuresList`);
				// pp.log("MEASURES marking open -- articleId, measureId, container, element", articleId, measureId, $measureContainer, $openedMeasure);
				if (!$openedMeasure.hasClass("Measure-option")) {
					$openedMeasure.detach();
					$measureContainer
						.find(".j-enacted-measures-delimiter")
						.before($openedMeasure);
				}
				// pp.log("- opened Measures -- DOM element, vote call button, Draft creatable", $openedMeasure, $openedMeasure.find('.Measure__call-vote-button'), $openedMeasure.attr('data-draft-creatable'))
				if ($openedMeasure.attr("data-draft-creatable") == "true") {
					// @ts-expect-error
					$openedMeasure.attr("data-show-as-closed", false); // If the Measure panel has not been fetched via `loadMeasureContent`
					$openedMeasure.data("showAsClosed", false); // Need to set this separately for jQuery to see the change
					$openedMeasure
						.find(".Measure__call-vote-button")
						.removeClass("disabled")
						.prop("disabled", false); // If the Measure panel has been fetched already
				}

				$openedMeasure.removeClass("Measure--state-closed");
				const $optionLinks = pp.measures.measureOptionLinks(
					articleId,
					measureId,
				);
				$optionLinks.removeClass("Measure--state-closed");
			});
		});
	},

	markClosedMeasures(articleMeasuresAsHash) {
		// pp.log("markClosedMeasures", articleMeasuresAsHash);
		Object.entries(articleMeasuresAsHash).forEach(([articleId, measureIds]) => {
			measureIds.forEach((measureId) => {
				const $closedMeasure = $(
					pp.measures.domElLookupString(articleId, measureId),
				);
				const $measureContainer = $($closedMeasure).closest(".MeasuresList");
				// pp.log("MEASURES marking closed -- articleId, measureId, container, element", articleId, measureId, $measureContainer, $closedMeasure);
				if (!$closedMeasure.hasClass("Measure-option")) {
					$closedMeasure.detach();
					$measureContainer
						.find(".j-closed-measures-delimiter")
						.after($closedMeasure);
				}

				$closedMeasure.addClass("Measure--state-closed");

				const $optionLinks = pp.measures.measureOptionLinks(
					articleId,
					measureId,
				);
				$optionLinks.addClass("Measure--state-closed");
			});
		});
	},

	updateDisplayValues(measuresContainerSelector) {
		const listData = this.watchedLists[measuresContainerSelector];
		if (listData === undefined) {
			console.error(
				`No watched list for selector ${measuresContainerSelector} found!`,
			);
			return;
		}
		const $articleIterationsMenu = $(".j-article-iterations-menu");
		// @ts-expect-error
		const maxDrafts = parseInt($articleIterationsMenu.attr("data-max-drafts"));
		const totalDrafts = parseInt(
			// @ts-expect-error
			$articleIterationsMenu.attr("data-total-drafts"),
		);
		const openDrafts = parseInt(
			// @ts-expect-error
			$articleIterationsMenu.attr("data-open-drafts"),
		);
		// Measures count, votes remaining
		listData.measuresCountEl.text(listData.enactedArticleMeasureIds.length);
		listData.remainingVotesEl.text(maxDrafts - totalDrafts + openDrafts);

		// Measures cost
		const totalDescriptor =
			listData.enactedMeasuresTotalCost < 1
				? I18n.t("measures.outgoing")
				: I18n.t("measures.savings");

		let totalAbs = Math.abs(listData.enactedMeasuresTotalCost);
		// @ts-expect-error
		totalAbs = numeral(Math.abs(listData.enactedMeasuresTotalCost)).format(
			totalAbs >= 10000 ? numeral.formatWithUnit : numeral.format,
		);
		listData.measuresTotalCostDescriptorEl.text(totalDescriptor);
		listData.measuresTotalCostEl.text(totalAbs);
	},

	initMeasureEffects(measureId, articleId, showEffectsPreview, votedOnDraftId) {
		pp.log(
			"MEASURES initMeasureEffects",
			measureId,
			articleId,
			showEffectsPreview,
		);
		const $measure = $(pp.measures.domElLookupString(articleId, measureId));

		pp.vue.lazyLoadPageVueInstances($measure);
		// Can't directly call `fetchEffectsPreview` without the Draft ID or the input value from the custom Modifier fields
		// The effects will then be called via `debounceUserDefinedModifiersPreview`
		if (votedOnDraftId || !$measure.find(".j-modifier-fields-wrapper").length) {
			if (!$measure.find(".Modifier__effect-row").length) {
				pp.log("- no effects");
				return;
			}
			pp.measures.fetchEffectsPreview(
				measureId,
				articleId,
				showEffectsPreview,
				votedOnDraftId,
			);
		} else {
			$measure
				.find(".j-modifier-fields-wrapper input[type='number']")
				.trigger("input");
		}
	},

	fetchEffectsPreview(
		measureId,
		articleId,
		showEffectsPreview,
		votedOnDraftId,
		userValue = null,
	) {
		$.ajax({
			url: `/measures/${measureId}/effects_preview`,
			type: "GET",
			data: {
				article_id: articleId,
				show_effects_preview: showEffectsPreview,
				draft_id: votedOnDraftId,
				user_value: userValue,
			},
			success: (data) => {
				// pp.log("data", data);
				Object.entries(data).forEach(([propertyId, effectsData]) => {
					// pp.log("at", propertyId, effectsData);
					pp.vue.bus.$emit("measure-effect-preview", {
						itemId: `prop-${propertyId}-measure-${measureId}`,
						effectsData: effectsData,
					});
				});
			},
		});
	},

	initDraftMeasuresFields(domSelector, measureId, index, showEffectsPreview) {
		var $measureForm = $(`${domSelector}[data-measure-id='${measureId}']`).find(
			"form",
		);
		pp.log("MEASURES initDraftMeasuresFields -- form obj", $measureForm);
		if (!$measureForm.length) {
			pp.log(
				`- could not find Measure for selector "${domSelector}[data-measure-id='${measureId}']"`,
			);
			return;
		}
		$measureForm.data("clientSideValidations").validators[
			`draft[drafts_measures_attributes][0][modifier_user_inputs][${index}][user_input]`
		] = pp.viewHelpers.clientSideValidatorsFor("modifier", "user_input");
		$measureForm.validate();
		$measureForm.find("input[type='number']").on("input", (event) => {
			pp.measures.debounceUserDefinedModifiersPreview(
				$measureForm,
				event,
				showEffectsPreview,
			);
		});
	},

	debounceUserDefinedModifiersPreview($measureForm, event, showEffectsPreview) {
		// pp.log("debounceUserDefinedModifiersPreview", event, showEffectsPreview);
		const clientSideValidationsFormSettings = $measureForm.data(
			"clientSideValidations",
		).html_settings;
		const $input = $(event.target);
		const modifierId = $input
			.closest(".j-modifier-fields-wrapper")
			.find("input[type='hidden'][name$='[id]']")
			.val();
		const $measure = $input.closest(".Measure, .Measure-option");

		if (pp.measures.previewUserDefinedModifiersTimeout !== null) {
			clearTimeout(pp.measures.previewUserDefinedModifiersTimeout);
		}
		// @ts-expect-error
		pp.measures.previewUserDefinedModifiersTimeout = setTimeout(() => {
			// This will also be the case when a non-numeral string has been entered
			if (!$input.val().length) {
				return;
			}
			// @ts-expect-error
			ClientSideValidations.formBuilders["SimpleForm::FormBuilder"].remove(
				$input,
				clientSideValidationsFormSettings,
			);
			$input.prop("disabled", true).addClass("disabled");
			$.ajax({
				url: `/measures/${$measure.attr("data-measure-id")}/effects_preview`,
				type: "GET",
				data: {
					article_id: $measure.attr("data-article-id"),
					modifier_id: modifierId,
					user_value: $input.val(),
					show_effects_preview: showEffectsPreview,
				},
				success: (data) => {
					// pp.log("data", data);
					const measureId = $measure.attr("data-measure-id");
					$input.prop("disabled", false).removeClass("disabled");
					Object.entries(data).forEach(([propertyId, effectsData]) => {
						// pp.log("at", propertyId, effectsData);
						pp.vue.bus.$emit("measure-effect-preview", {
							itemId: `prop-${propertyId}-measure-${measureId}`,
							effectsData: effectsData,
						});
					});
				},
			});
		}, 1000);
	},
};
